import React from "react";
import { MONTHS } from "./Constants";
// used in dashboard index page, orders,chargerDetails and userDetails page
export const computeTime = (isodate) => {
  if (isodate == null) return "";
  const date = new Date(isodate);
  let hour = date.getHours().toString();
  let mins = date.getMinutes().toString();
  let secs = date.getSeconds().toString();

  if (hour.length < 2) hour = "0" + hour;

  if (mins.length < 2) mins = "0" + mins;

  if (secs.length < 2) secs = "0" + secs;

  return hour + ":" + mins + ":" + secs;
};

export const computeDate = (isodate) => {
  if (isodate == null) return "";
  const date = new Date(isodate);
  let day = date.getDate();
  let month = date.getMonth();
  let year = date.getFullYear().toString();

  if (day < 10) day = "0" + day.toString();

  if (month < 10) month = "0" + month.toString();

  return day + " " + MONTHS.at(month) + ", " + year;
};

export const computeConsumption = (starMeterVal, stopMeterVal) => {
  if (isNaN(starMeterVal)) return "";

  if (isNaN(stopMeterVal)) return <div className="badge badge-soft-warning font-size-12">On-going</div>;

  return ((parseInt(stopMeterVal, 10) - parseInt(starMeterVal, 10)) / 1000).toString();
};

export const computeTotal = (starMeterVal, stopMeterVal, perUnitRate) => {
  if (isNaN(stopMeterVal)) return <div className="badge badge-soft-warning font-size-12">On-going</div>;
  if (isNaN(starMeterVal) || isNaN(stopMeterVal) || starMeterVal > stopMeterVal) {
    return 0;
  }
  return (((parseInt(stopMeterVal, 10) - parseInt(starMeterVal, 10)) * perUnitRate) / 1000).toString();
};

export const computePaymentStatus = (starMeterVal, stopMeterVal) => {
  if (isNaN(stopMeterVal)) return <div className="badge badge-soft-warning font-size-12">Paid</div>;

  return <div className="badge badge-soft-success font-size-12">Paid</div>;
};

// Compute the number of units consumed
export const computeUnits = (startMeterVal, stopMeterVal) => {
  if (isNaN(startMeterVal) || isNaN(stopMeterVal) || startMeterVal > stopMeterVal) {
    return 0;
  }
  return (stopMeterVal - startMeterVal) / 1000;
};

// computes the revenue for the transaction
export const computeRevenue = (startMeterVal, stopMeterVal, perUnitRate) => {
  if (isNaN(startMeterVal) || isNaN(stopMeterVal) || isNaN(perUnitRate) || startMeterVal > stopMeterVal) {
    return 0;
  }
  return ((stopMeterVal - startMeterVal) * perUnitRate) / 1000;
};

// computes the total energy
export const computeTotalEnergy = (totalPower, numberOfDays, numberOfHrs) => {
  if (isNaN(totalPower) || isNaN(numberOfDays) || isNaN(numberOfHrs)) {
    return 0;
  }
  return totalPower * numberOfDays * numberOfHrs;
};

// iNPUT REQUIRED
export const inputRequired = ()=>{
 return <span style={{fontWeight:"400",fontSize:"18px",color:"#DC272D"}}> *</span>
}

// *************************************************IMAGE UTILS********************************************************
// // format the image base64 str obtained from the server to valid base64
export const formatBase64 = (str) => {
  // Return if already formatted correctly
  if (str.startsWith("data:image")) {
    return str.trim();
  }

  // Match base64 image data without full prefix
  const regex = /image\/([a-zA-Z0-9+.-]+);?base64,?(.+)/;
  const matches = str.match(regex);

  if (matches && matches[1] && matches[2]) {
    const imgType = matches[1].trim();

    let base64Data = matches[2].trim().replace(/[^A-Za-z0-9+/=]/g, ""); // Clean junk chars
    base64Data = base64Data.replace(/=+$/, ""); // Remove trailing '='

    return `data:image/${imgType};base64,${base64Data}`;
  }

  console.warn("Could not parse base64 string:", str);
  return str.trim(); // Fallback
};

const isValidBase64 = (str) => {
  try {
    atob(str);
    return true;
  } catch {
    return false;
  }
};
/**
 * Convert a base64 image string to a Blob object
 * @param {string} str - Base64 image string
 * @returns {Blob|null} - Image Blob or null if parsing fails
 */
export const formatBase64ToBlob = (str) => {
  try {
    if (!str || typeof str !== "string") return null;

    if (str.startsWith("data:image")) {
      const [header, base64Data] = str.split(",");
      const mimeMatch = header.match(/data:([^;]+);base64/);

      if (!mimeMatch || !isValidBase64(base64Data)) return null;

      const mimeType = mimeMatch[1];
      const binaryStr = atob(base64Data);
      const bytes = new Uint8Array(binaryStr.length);
      for (let i = 0; i < binaryStr.length; i++) {
        bytes[i] = binaryStr.charCodeAt(i);
      }

      return new Blob([bytes], { type: mimeType });
    }
    const regex = /image\/([a-zA-Z0-9+.-]+);?base64,?(.+)/;
    const matches = str.match(regex);
    if (matches && matches[1] && matches[2]) {
      const mimeType = `image/${matches[1].trim()}`;
      let base64Data = matches[2].trim().replace(/[^A-Za-z0-9+/=]/g, ""); // Clean junk chars
      base64Data = base64Data.replace(/=+$/, ""); // Remove trailing '='
      // const base64Data = matches[2];
      const binaryStr = atob(base64Data);
      const bytes = new Uint8Array(binaryStr.length);
      for (let i = 0; i < binaryStr.length; i++) {
        bytes[i] = binaryStr.charCodeAt(i);
      }

      return new Blob([bytes], { type: mimeType });
    }

    console.warn("Could not parse base64 string to Blob:", str);
    return null;
  } catch (error) {
    console.error("Error converting base64 to Blob:", error);
    return null;
  }
};

// convert the image file to base64 encoding
export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.readAsDataURL(file); // Start reading here

    fileReader.onload = () => {
      resolve(fileReader.result); // Base64 result returned
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};
